import Swal from 'sweetalert2'

import APIs from '../../../api'
import { apiClient } from '../../../api/client'
import { LANGUAGE_CODE_TO_NAME } from '../../../constants'
import { tokenStorage } from '../../../utils/tokenStorage'

// GET `${PRODUCTS.LIST}` (resolved against apiClient.baseURL)
// Expected payload shape:
//   { result: [{ id, name, status, ... }], statuscode, status }
// The list drives the cards rendered on the product-selection screen.
export const listProductsApi = async () => {
  const res = await apiClient.get(APIs.PRODUCTS.LIST)
  return res?.data?.result || []
}

// GET `${CUSTOMER_URL}/guardian-users/me`
// Required headers:
//   - Authorization: <accessToken> from tokenStorage (the backend expects the
//     raw JWT — no `Bearer ` prefix, matching the curl in the spec).
//   - platform: MDG_GUARDIAN
export const getGuardianMeApi = async () => {
  const token = tokenStorage.getAccessToken()
  const url = APIs.AUTH.me
  try {
    // Only attach the `language` header once the user is authenticated. The
    // pre-auth flows (login, forgot-password) never see it so the backend
    // doesn't have to whitelist an extra header on those surfaces.
    const storedCode =
      typeof window !== 'undefined'
        ? window.localStorage.getItem('mdg.preferredLanguage') || 'en'
        : 'en'
    const langName = token ? LANGUAGE_CODE_TO_NAME[storedCode] || 'english' : null

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        accept: '*/*',
        platform: 'MDG_GUARDIAN',
        ...(token ? { Authorization: token } : {}),
        ...(token && langName ? { language: langName } : {}),
      },
    })
    if (res.status === 401) {
      // Token is invalid/expired — drop it, surface a swal error, and bounce
      // the user back to /login so they can re-authenticate.
      tokenStorage.clearTokens()
      await Swal.fire({
        title: 'Session expired',
        text: 'Your session has ended. You will be redirected to the login page.',
        icon: 'error',
        iconColor: '#DC3545',
        confirmButtonText: 'Login',
        confirmButtonColor: '#3B82F6',
        cancelButtonColor: '#151f3b',
        background: 'var(--card-bg, #ffffff)',
        color: 'var(--text-primary, #212529)',
        customClass: {
          confirmButton: 'swal-btn-primary',
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      window.location.href = '/login'
      const err = new Error('HTTP 401 Unauthorized')
      err.status = 401
      throw err
    }
    if (!res.ok) {
      const text = await res.text().catch(() => '')
      const err = new Error(`HTTP ${res.status} ${res.statusText}${text ? ` — ${text}` : ''}`)
      err.status = res.status
      throw err
    }
    return res.json()
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[getGuardianMeApi] network error', err)
    throw err
  }
}
